import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { Modal } from "@/shared/ui/modal"
import notify from "@/shared/lib/notify"
import { getErrorMessage } from "@/shared/consts/error-codes"
import { closeUserBroadcastModal, fetchUserBroadcast, selectIsUserBroadcastModalOpen, selectOnSuccess } from "../../model"
import { TelegramTextEditor } from "@/shared/ui/telegram-rich-text-editor"
import { useRef, useState } from "react"
import XSvg from '@/shared/assets/images/X.svg'

export const UserBroadcastModal = () => {
    const dispatch = useAppDispatch()
    const isOpen = useAppSelector(selectIsUserBroadcastModalOpen)
    const onSuccess = useAppSelector(selectOnSuccess)
    const fileInputRef = useRef<HTMLInputElement>(null)
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [image, setImage] = useState<File | undefined>(undefined)
    const [markup, setMarkup] = useState<string>('')

    const handleClose = () => {
        dispatch(closeUserBroadcastModal())
        setImage(undefined)
        setMarkup('')
    }

    const onSubmit = async () => {
        if (!markup) {
            notify.error('Введите сообщение')
            return
        }

        setIsLoading(true)
        try {
            await dispatch(fetchUserBroadcast({
                image,
                message: markup
            })).unwrap()
            
            notify.success('Уведомление успешно отправлено')
            setImage(undefined)
            setMarkup('')
            onSuccess?.()
            handleClose()
        } catch (error) {
            notify.error(getErrorMessage(error))
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <Modal
            isOpen={isOpen}
            title="Отправка уведомления"
            onRequestClose={handleClose}
        >
            <div className="flex flex-col gap-3">
                <div className="flex flex-col bg-white rounded-2xl">
                    <div className="flex w-full">
                        <div className="flex-1 w-full">
                            <TelegramTextEditor
                                onInputChange={setMarkup}
                            />
                        </div>
                    </div>
                    <div className="flex pt-4 gap-3 flex-col border-t border-[#EAECF0]">
                        <div className='flex'>
                            <button 
                                type="button"
                                onClick={() => fileInputRef?.current?.click()} 
                                className='bg-[#f0efef] font-semibold relative rounded-[4px] w-12 h-9'
                            >
                                +
                            </button>
                            {image &&
                                <div className='px-2 my-auto bg-primary flex items-center ml-2 text-color-dark py-[2px] rounded-sm'>
                                    <div>
                                        {image.name}
                                    </div>
                                    <div className='h-full w-[1px] bg-white px-[2px]' />
                                    <button type="button" onClick={() => setImage(undefined)}>
                                        <XSvg width={16} height={16}/>
                                    </button>
                                </div>
                            }
                            <input
                                type="file"
                                className='hidden absolute'
                                ref={fileInputRef}
                                accept="image/*"
                                onChange={(e) => e.target.files?.length && setImage(e.target.files[0])}
                            />
                        </div>
                    </div>
                </div>
                <div className="w-full flex gap-3">
                    <button onClick={handleClose} className="form_cancel_button">
                        Отменить
                    </button>
                    <button disabled={isLoading} onClick={onSubmit} className="form_handle_button" type="button">
                        Отправить
                    </button>
                </div>
            </div>
        </Modal>
    )
}

